module.exports = __webpack_public_path__ + "media/images/new/airstreams_and_tetons-57b9a8c7c6efebd8239294ec9da09707.jpeg";